export enum ValidationError {
    MinAmount = 1,
    MaxFraction = 2,
    IncompleteDistribution = 3,
    Zero = 4
  }
